module.exports = __webpack_public_path__ + "static/media/emina_logo_big.1e6fe976.png";